(function () {
	const debounce = (fn, ms) => {
		let t;
		return (...args) => {
			clearTimeout(t);
			t = setTimeout(() => fn(...args), ms);
		};
	};

	const emptyIsUndefined = (value) => {
		const v = (value ?? '').trim();
		return v === '' ? undefined : v;
	};

	const fetchJson = (url, init) => fetch(url, init).then((r) => r.json());

	const init = async (search) => {
		const projectId = Number(search.dataset.project || 0);
		const fromAttr = emptyIsUndefined(search.dataset.from);
		const toAttr = emptyIsUndefined(search.dataset.to);
		const includeHidden = search.dataset.includeHidden === '1';
		const inputLocation = search.querySelector('.search-input-location');
		const selectType = search.querySelector('.search-select-type');
		const inputCity = search.querySelector('.search-input-city');
		const inputDay = search.querySelector('.search-input-day');
		const btnReset = search.querySelector('.search-button-reset');
		const list = search.querySelector('.search-list');
		const searchResults = search.querySelector('.search-results');

		const citiesParams = new URLSearchParams();
		if (projectId > 0) citiesParams.set('project', String(projectId));
		if (fromAttr) citiesParams.set('from', fromAttr);
		if (toAttr) citiesParams.set('to', toAttr);
		const citiesQuery = citiesParams.toString();
		const citiesUrl = `/wp-json/e3-events/v1/cities${citiesQuery ? `?${citiesQuery}` : ''}`;

		const [eventTypes, projects, cities, allAds] = await Promise.all([
			fetchJson('/wp-json/wp/v2/event-types?per_page=100&unlimited&_fields=id,name'),
			fetchJson('/wp-json/wp/v2/project?per_page=100&unlimited&_fields=id,title,meta'),
			fetchJson(citiesUrl),
			fetchJson('/wp-json/e3-events/v1/ads').catch(() => []),
		]);

		// Only ads assigned to this project are shown in the project calendar.
		const ads = (allAds || []).filter((ad) => ad.project === projectId);

		eventTypes
			.slice()
			.sort((a, b) => (a.name < b.name ? -1 : 1))
			.forEach((t) => {
				const option = document.createElement('option');
				option.value = String(t.id);
				option.text = t.name;
				selectType.add(option);
			});

		(cities || []).forEach((c) => {
			const option = document.createElement('option');
			option.value = c;
			option.text = c;
			inputCity.add(option);
		});

		const projectMap = new Map(
			projects.map((p) => [
				p.id,
				{
					id: p.id,
					title: (p.title?.rendered ?? p.title?.raw ?? '').replace(/&#(\d+);/g, (_, d) => String.fromCharCode(d)),
					color: p.meta?._main_color ?? 'black',
				},
			]),
		);

		let initialPopulated = false;

		const heartSvg = `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24.95 22" width="24" height="24"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" stroke="currentColor" fill="none" d="M12.48,6s1.37-5,5.71-5C21.57,1,24,3.87,24,7.26,24,12,19.25,15.07,12.48,21,5.7,15.07,1,12,1,7.26,1,3.87,3.38,1,6.76,1,11.1,1,12.48,6,12.48,6Z"/></svg>`;

		// Ads are injected into the events list at fixed positions (every AD_INTERVAL slots).
		const AD_INTERVAL = 3;
		const renderAd = (ad) => {
			const img = `<img src="${ad.image}" alt="${ad.title ?? ''}" />`;
			const content = ad.link
				? `<a href="${ad.link}" target="_blank" rel="noopener noreferrer">${img}</a>`
				: img;
			const title = ad.link
				? `<a href="${ad.link}" target="_blank" rel="noopener noreferrer">Anzeige</a>`
				: `Anzeige`;
			return `<div class="event-item ad-item" data-ad="${ad.id}">
				<div class="event-item-img">${content}</div>
				<h3 class="event-item-title">${title}</h3>
			</div>`;
		};

		const renderEvent = (item) => {
			const project = projectMap.get(item.project);
			const color = project?.color ?? 'black';
			return `<div class="event-item" data-id="${item.id}" style="--event-color: ${color}">
				${
					item.image
						? `<div class="event-item-img">
							<span class="heart" data-heart="${item.id}">${heartSvg}</span>
							<a href="${item.link}"><img src="${item.image}" alt="${item.title}" /></a>
						</div>`
						: ''
				}
				${project ? `<span class="category">${project.title}</span>` : ''}
				<h3 class="event-item-title"><a href="${item.link}">${item.title}</a></h3>
				<div>${item.tagline}</div>
			</div>`;
		};

		const doSearch = debounce(async () => {
			const day = emptyIsUndefined(inputDay.value);
			const payload = {
				project: projectId > 0 ? projectId : undefined,
				type: emptyIsUndefined(selectType.value),
				location: emptyIsUndefined(inputLocation.value),
				city: emptyIsUndefined(inputCity.value),
				from: day ?? fromAttr,
				to: day ?? toAttr,
				includeHidden: includeHidden ? true : undefined,
			};

			const json = await fetchJson('/wp-json/e3-events/v1/search', {
				method: 'POST',
				headers: {
					Accept: 'application/json',
					'Content-Type': 'application/json',
				},
				body: JSON.stringify(payload),
			});

			if (!initialPopulated) {
				initialPopulated = true;

				const usedTypes = new Set(
					json.map((x) => x.eventType).filter((x) => x !== null && x !== undefined),
				);
				Array.from(selectType.options).forEach((opt) => {
					if (opt.value !== '' && !usedTypes.has(Number(opt.value))) {
						selectType.removeChild(opt);
					}
				});
			}

			searchResults.innerHTML = `Ihr Suchergebnis: ${json.length} Treffer`;

			// Interleave ads at fixed positions (every AD_INTERVAL slots); each ad is shown only once.
			const items = [];
			let eventIdx = 0;
			let adIdx = 0;
			let position = 1;
			while (eventIdx < json.length) {
				if (adIdx < ads.length && position % AD_INTERVAL === 0) {
					items.push(renderAd(ads[adIdx]));
					adIdx++;
				} else {
					items.push(renderEvent(json[eventIdx]));
					eventIdx++;
				}
				position++;
			}
			list.innerHTML = items.join('');

			window.dispatchEvent(new CustomEvent('krfrm:search-rendered', { detail: { container: search } }));
		}, 300);

		inputLocation.addEventListener('input', doSearch);
		selectType.addEventListener('change', doSearch);
		inputCity.addEventListener('change', doSearch);
		inputDay.addEventListener('change', doSearch);

		btnReset.addEventListener('click', () => {
			inputLocation.value = '';
			selectType.selectedIndex = 0;
			inputCity.selectedIndex = 0;
			inputDay.value = '';
			doSearch();
		});

		doSearch();
	};

	const start = () => {
		document.querySelectorAll('.search.search-project').forEach((el) => {
			if (el.dataset.initialized === '1') return;
			el.dataset.initialized = '1';
			init(el);
		});
	};

	if (document.readyState === 'loading') {
		document.addEventListener('DOMContentLoaded', start);
	} else {
		start();
	}
})();
